// src/App.js
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import Projects from "./pages/Projects";
import ProjectForm from "./pages/ProjectForm";
import Applications from "./pages/Applications";
import Contributions from "./pages/Contributions";
import Login from "./pages/Login";
import "./App.css";

function App() {
  const [auth, setAuth] = useState(Boolean(localStorage.getItem("admin_auth")));

  const handleLogin = () => {
    localStorage.setItem("admin_auth", "1");
    setAuth(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("admin_auth");
    setAuth(false);
    window.location.href = "/";
  };

  if (!auth) return <Login onLogin={handleLogin} />;

  return (
    <Router>
      <div className="admin-shell">
        <Sidebar onLogout={handleLogout} />
        <div className="admin-content">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/new" element={<ProjectForm />} />
            <Route path="/projects/edit/:id" element={<ProjectForm />} />
            <Route path="/applications" element={<Applications />} />
            <Route path="/contributions" element={<Contributions />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;

